/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CustomApp56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <circle cx={48} cy={8} r={8} fill={vars.bdlBoxBlue10} />
            <circle cx={4} cy={52} r={4} fill={vars.bdlBoxBlue10} />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M39 5c6.627 0 12 5.373 12 12v22c0 6.627-5.373 12-12 12H17c-6.628 0-12-5.373-12-12V17c0-6.627 5.372-12 12-12h22z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M39 7H17c-5.43 0-9.848 4.327-9.997 9.72L7 17v22c0 5.43 4.326 9.848 9.72 9.996L17 49h22c5.429 0 9.848-4.327 9.996-9.72L49 39V17c0-5.43-4.327-9.848-9.72-9.996L39 7z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M31.548 19c.598 0 1.179.175 1.67.504l.18.13.201.175 6.563 6.23a2.704 2.704 0 01.29 3.59l-.118.147-.182.194-6.55 6.219a2.973 2.973 0 01-2.054.811 3 3 0 01-1.671-.506l-.18-.13-.204-.177-1.497-1.438-1.526 1.441c-.44.42-1.009.69-1.618.778l-.23.025-.21.007c-.6 0-1.181-.175-1.675-.504l-.181-.13-.204-.177-6.51-6.227a2.698 2.698 0 01-.293-3.59l.118-.147.18-.192 6.506-6.223a2.987 2.987 0 012.059-.81c.599 0 1.18.175 1.674.504l.181.13.204.177 1.506 1.44 1.518-1.44a2.95 2.95 0 011.614-.78l.23-.024.21-.007z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M31.548 21.028a.834.834 0 00-.348.076l-.095.054-.111.09-1.518 1.437 3.492 3.341c1.037.973 1.154 2.506.305 3.61l-.121.149-.184.19-1.073 1.006a1.097 1.097 0 01-1.501-.014.98.98 0 01-.165-1.206l.07-.107.109-.12 1.073-1.007a.708.708 0 00.157-.85l-.063-.098-.102-.113-6.502-6.22a.813.813 0 00-.56-.218.857.857 0 00-.353.076l-.096.054-.108.087-6.499 6.216a.74.74 0 00-.162.864l.062.1.095.109 6.502 6.22c.146.139.348.218.56.218.126 0 .25-.028.354-.077l.096-.054.112-.09 1.525-1.442-3.471-3.337a2.676 2.676 0 01-.304-3.607l.121-.148.183-.19 1.068-1.006a1.097 1.097 0 011.501.01.98.98 0 01.168 1.206l-.07.107-.108.121-1.068 1.006a.714.714 0 00-.157.853l.063.098.101.114 6.47 6.22a.799.799 0 00.552.216.835.835 0 00.349-.076l.095-.054.11-.09 6.544-6.211c.246-.24.3-.592.163-.866l-.06-.098-.093-.108-6.556-6.224a.799.799 0 00-.552-.217z"
            />
        </g>
    </AccessibleSVG>
);

export default CustomApp56;
